// extracted by mini-css-extract-plugin
module.exports = {"main":"button_main__f2dwC","normal":"button_normal__3ycaj","colorful":"button_colorful__1S-nZ","button":"button_button__2Z8SW"};